import React from "react";

export default function Icon(props) {
  const TagName = props.icon;
  const { ...other } = props;
  return <TagName {...other} />;
}
